
import React from 'react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Plus } from 'lucide-react';
import { getAvailableDynamicFields } from './dynamicFieldProcessor';

interface DynamicFieldSelectorProps {
  onFieldSelect: (field: string) => void;
  disabled?: boolean;
}

const DynamicFieldSelector: React.FC<DynamicFieldSelectorProps> = ({ 
  onFieldSelect, 
  disabled = false 
}) => {
  const dynamicFields = getAvailableDynamicFields();

  const handleFieldClick = (fieldValue: string) => {
    onFieldSelect(fieldValue);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button 
          type="button" 
          variant="outline" 
          size="sm" 
          disabled={disabled}
          className="text-xs"
        >
          <Plus className="h-3 w-3 mr-1" />
          Add Dynamic Field
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 max-h-96 overflow-y-auto" align="start">
        <div className="space-y-4">
          <h4 className="font-medium text-sm text-gray-900">Select a Dynamic Field</h4>
          
          {Object.entries(dynamicFields).map(([category, fields]) => (
            <div key={category} className="space-y-2">
              <h5 className="text-xs font-medium text-gray-700 uppercase tracking-wide">
                {category.replace('_', ' ')}
              </h5>
              <div className="grid gap-1">
                {fields.map((field) => (
                  <button
                    key={field.value}
                    type="button"
                    onClick={() => handleFieldClick(field.value)}
                    className="text-left text-xs p-2 rounded hover:bg-gray-100 transition-colors"
                  >
                    <div className="font-medium text-gray-900">{field.label}</div>
                    <div className="text-gray-500 font-mono">{field.value}</div>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default DynamicFieldSelector;
